import { memo } from 'react';
import { ExpandColumnRightIcon } from '@page/icons';

import { cn } from '../../lib/styles';
import { IconButton, PageHeader, PageHeaderProps } from '../../designSystem';

interface RightRailLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const RightRailHeader = ({
  left,
  bottom,
  onClose,
  ...rest
}: PageHeaderProps & { bottom?: React.ReactNode; onClose?: () => void }) => {
  return (
    <div className="flex flex-col border-b border-border-default">
      <PageHeader
        left={
          left ?? (
            <IconButton variant="secondary" onClick={onClose}>
              <ExpandColumnRightIcon className="size-5" />
            </IconButton>
          )
        }
        {...rest}
      />

      {bottom}
    </div>
  );
};

const RightRailLayoutBase = ({ children, className }: RightRailLayoutProps) => {
  return <div className={cn('flex flex-col shadow-md h-full', className)}>{children}</div>;
};

export const RightRailLayout = memo(RightRailLayoutBase);
